import axios from "axios";
import { apiBaseUrl, defaultSubdomian } from "../../config/const";
import { refresh } from "../../redux/actions/config/session";
import { flashError } from "./flashMessage";

import history from "./history";

// https://github.com/sindresorhus/is-absolute-url/blob/master/index.js#L7

export function errorDesconocido() {
    flashError({
        title: "Error inesperado",
        description: "Lo sentimos pero ha ocurrido un error desconocido, por favor vuelva a intentar más tarde.",
    });
}

export async function getPublicHttpClient(dispatch, state) {
    const api = axios.create();

    let subdomain = window.location.host.split(".")[1] ? window.location.host.split(".")[0] : false;
    subdomain = subdomain === defaultSubdomian ? "" : subdomain;

    const burl = apiBaseUrl(subdomain);

    api.defaults.baseURL = burl;

    return api;
}

export async function getHttpClient(dispatch, state) {
    const api = axios.create();
    const subdominio = state.config.session.data.subdomain;
    const token = state.config.session.data.token;
    const exp = state.config.session.data.exp;
    const burl = apiBaseUrl(subdominio);
    const now = Date.now().valueOf() / 1000;

    api.defaults.baseURL = burl;
    api.defaults.headers.Authorization = "Bearer " + token;

    try {
        if (exp < now + 60) {
            const data = await refresh(dispatch, state);
            api.defaults.headers.Authorization = "Bearer " + data.token;
        }
    } catch (e) {
        return "Error";
    }

    return api;
}

export const handle401 = (dispatch, state) => (err) => {
    if (err.response) {
        if (err.response.status == 401) {
            dispatch({
                type: "CONFIG_SESSION_RESET",
            });
            alert("Su sesión ha caducado");

            flashError({
                title: "Su sesión ha expirado",
                description: "Lo sentimos pero su sesión ha caducado, por favor vuelva a ingresar.",
            });

            history.push("/auth/login");
            return true;
        }
    }
    throw err;
};

export const safeHandle401 = (dispatch, state) => (err) => {
    if (err.response) {
        if (err.response.status == 401) {
            dispatch({
                type: "CONFIG_SESSION_RESET",
            });
            flashError({
                title: "Su sesión ha expirado",
                description: "Lo sentimos pero su sesión ha caducado, por favor vuelva a ingresar.",
            });

            history.push("/auth/login");
            return true;
        }
    }
    return;
};
